// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__duL78","wrapper":"style_wrapper__dOD7D","mobile":"style_mobile__e1ao+","laptop":"style_laptop__4vrLO"};